import { render, staticRenderFns } from "./TableColumnsPropertyEditor.vue?vue&type=template&id=0fad05d1&scoped=true&"
import script from "./TableColumnsPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./TableColumnsPropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad05d1",
  null
  
)

export default component.exports